// extracted by mini-css-extract-plugin
export var aircallIframe = "_gy-3";
export var fabContainer = "_gy-5";
export var fabRinging = "_gy-6";
export var loadingOverlay = "_gy-4";
export var pulse = "_gy-7";
export var widgetContent = "_gy-2";
export var widgetPanel = "_gy-0";
export var widgetPanelExpanded = "_gy-1";